const inputWrappers = document.querySelectorAll('[data-input-wrapper]');

inputWrappers.forEach((inputWrapper) => {
  const inputElement = inputWrapper.querySelector('input');
  const labelElement = inputWrapper.querySelector('label');

  if (inputElement.value.length >= 1) {
    inputElement.setAttribute('data-input-act', '');
    labelElement.setAttribute('data-input-act', '');
  }
  
  // eslint-disable-next-line func-names
  inputElement.addEventListener('input', function () {
    if (this.value.length >= 1) {
      this.setAttribute('data-input-act', '');
      labelElement.setAttribute('data-input-act', '');
    } else {
      this.removeAttribute('data-input-act');
      labelElement.removeAttribute('data-input-act');
    }
  });
});
